<template>
  <div class="property-input">
    <label class="property-label">
      {{ property.text ? property.text : property.name }}
      <Tooltip v-if="property.tooltip" :text="property.tooltip" />
    </label>
    <div class="property-toggle">
      <input 
        type="checkbox" 
        :checked="element" 
        @change="updateProperty({element: container, property: property, value: $event.target.checked})"
        class="property-checkbox"
      />
      <span class="property-toggle-slider"></span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import Tooltip from "../Tooltip.vue";

export default {
  name: 'BooleanInput',
  props: {
    property: {
      type: Object,
      required: true
    },
    element: {
      type: Boolean,
      required: true
    },
    container: {
      type: Object,
      required: true
    }
  },
  components: {
    Tooltip
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'updateProperty': actions.UPDATE_PROPERTY
    }),
  },
}
</script>

<style scoped>
.property-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 0.375rem;
}

.property-label {
  font-size: 1rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, 1);
  color: #e5e7eb;
  display: flex;
  justify-content: space-between;
}

.property-toggle {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 1.5rem;
}

.property-checkbox {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
}

.property-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  transition: .4s;
  border-radius: 1.5rem;
}

.property-toggle-slider:before {
  position: absolute;
  content: "";
  height: 1.25rem;
  width: 1.25rem;
  left: 0.125rem;
  bottom: 0.125rem;
  background-color: #e5e7eb;
  transition: .4s;
  border-radius: 50%;
}

.property-checkbox:checked + .property-toggle-slider {
  background-color: #3b82f6;
}

.property-checkbox:checked + .property-toggle-slider:before {
  transform: translateX(1.5rem);
}

.property-checkbox:focus + .property-toggle-slider {
  box-shadow: 0 0 1px #3b82f6;
}
</style>
